import { colors } from '@mui/material';


export const onboardingSteps = [
  {
    label: 'Step 1',
    title: 'Register Your Business',    
    media: '/assets/home/register_shop.png',
    list: [ "Register Your Business Name",
            "Enter App nae of your choice",
            "Upload your Logo",
            "Set Business Contact details",
          ],
    conclusion: "You have set your digital foundation"
  },
  {
    label: 'Step 2',
    title: 'Configure',    
    media: '/assets/home/mperito_organize.png',
    list: [ "Define your Categories",
            "Add products with details",
            "Congfigure your delivery options",
            "Set your payment options",
          ],
    conclusion: "Your online shop is ready to open"
  },
  {
    label: 'Step 3',
    title: 'Launch',    
    media: '/assets/home/mperito_launch.png',
    list: [ "You just need to say \"Let's Launch\"",
            "Launch your online commerce in hours",
            "We launch Your App on Playstore",
            "We launch Your App on App Store",
          ],
    conclusion: "Get ready to serve your online customers"
  },
]

export const techPartner = [
  {
    color: colors.lightBlue[500],
    title: 'Catalog',
    subtitle: 'Simplified yet powerful catalog.',
    icon: (
      <svg
        height={24}
        width={24}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
        />
      </svg>
    ),
  },
  {
    color: colors.purple[500],
    title: 'Inventory',
    subtitle: 'Manage product pricing and inventory on the go.',
    icon: (
      <svg
        height={24}
        width={24}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
        />
      </svg>
    ),
  },
  {
    color: colors.yellow[500],
    title: 'Payments',
    subtitle: 'Get the payments directly in your bank Account.',
    icon: (
      <svg
        height={24}
        width={24}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
        />
      </svg>
    ),
  },
  {
    color: colors.indigo[500],
    title: 'Multichannel Sales',
    subtitle: 'Sell through Multichannel with one control panel.',
    icon: (
      <svg
        height={24}
        width={24}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
        />
      </svg>
    ),
  },
  {
    color: colors.red[500],
    title: 'Business Focus',
    subtitle: 'Continue focus on business as technology challenges are taken care by platform.',
    icon: (
      <svg
        height={24}
        width={24}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
        />
      </svg>
    ),
  },
  {
    color: colors.green[500],
    title: 'Operations',
    subtitle: 'Business Dashboard to empower day to day ecommerce operations.',
    icon: (
      <svg
        height={24}
        width={24}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"
        />
      </svg>
    ),
  },
  {
    color: colors.orange[500],
    title: 'Insights',
    subtitle: 'Business Insights to make strategic decisions on products and pricing.',
    icon: (
      <svg
        height={24}
        width={24}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    ),
  },
  {
    color: colors.deepPurple[500],
    title: 'Saving',
    subtitle: 'Save on device costs by leveraging mobile and tablets.',
    icon: (
      <svg
        height={24}
        width={24}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122"
        />
      </svg>
    ),
  },
]











// TODO_SP The below data needs to be removed later

export const partners = [
  {
    name: 'Airbnb',
    logo: 'https://assets.maccarianagency.com/the-front/logos/airbnb.svg',
  },
  {
    name: 'Coinbase',
    logo: 'https://assets.maccarianagency.com/the-front/logos/coinbase.svg',
  },
  {
    name: 'Dribbble',
    logo: 'https://assets.maccarianagency.com/the-front/logos/dribbble.svg',
  },
  {
    name: 'Instagram',
    logo: 'https://assets.maccarianagency.com/the-front/logos/instagram.svg',
  },
  {
    name: 'Netflix',
    logo: 'https://assets.maccarianagency.com/the-front/logos/netflix.svg',
  },
  {
    name: 'Pinterest',
    logo: 'https://assets.maccarianagency.com/the-front/logos/pinterest.svg',
  },
];

export const features = [
  {
    label: 'STRATEGY',
    title: 'Business Transformation',
    description:
      'We transform businesses into brands through enhanced shoppable experience, content and marketing solutions',
    illustration: '/assets/images/solution/transformation.jpg',
    list: [ "Business Consulting",
            "Business Process Analysis",
            "End 2 End Process Consulting",
            "Enhance Shoppable Experience",
            "Digital Content and Marketing"
          ]
  },
  {
    label: 'SOLUTION',
    title: 'Digital Enablement',
    description:
      'We build solutions to ensure your teams are digitally enabled to focus more on business and generate value for customers',
    illustration: '/assets/images/solution/enablement.jpg',
    list: [
      "Startups Tech Enablement",
      "Digital Benchmarking",
      "Automate operations",
      "TCO Analysis & Optimization",
      "Ecommerce Implementation",
      "Content & Marketing",
      "SEO",
      "Data Analytics",
      "Cloud Enablement",
      "Specialized Consultants",
    ]
  },
  {
    label: 'DELIVERY',
    title: 'Engineering Solutions',
    description:
      'We help organizations to implementing long lasting & scalable end to end solutions by leveraging platforms and microservices',
    illustration: '/assets/images/solution/delivery.jpg',
    list: [
      "Consulting Services",
      "eCommerce ( B2C, B2B, Marketplace ) Solutions",
      "Microservices and Headless Experience",
      "Content & Marketing Solutions",
      "Mobile Application Development",
      "Custom & Specialized Solutions ( Dashboards, Workflows)",
      "PWA Enablement",
      "Managed Services"
    ],
  },
];

export const browsers = [
  {
    name: 'Google Chrome',
    logo: 'https://assets.maccarianagency.com/the-front/illustrations/browsers/chrome.png',
    title: 'Google Chrome is a cross-platform web browser developed by Google.',
  },
  {
    name: 'Safari',
    logo: 'https://assets.maccarianagency.com/the-front/illustrations/browsers/safari.png',
    title:
      'Safari is a graphical web browser developed by Apple, based on the WebKit engine.',
  },
  {
    name: 'Internet Explorer',
    logo: 'https://assets.maccarianagency.com/the-front/illustrations/browsers/explorer.png',
    title:
      'Internet Explorer is a series of graphical web browsers developed by Microsoft.',
  },
  {
    name: 'Mozilla Firefox',
    logo: 'https://assets.maccarianagency.com/the-front/illustrations/browsers/firefox.png',
    title:
      'Mozilla Firefox, or simply Firefox, is a free and web browser developed by the Mozilla.',
  },
  {
    name: 'Microsoft Edge',
    logo: 'https://assets.maccarianagency.com/the-front/illustrations/browsers/edge.png',
    title:
      'Microsoft Edge is a web browser developed by Microsoft. It was first released for Windows 10.',
  },
];

export const advantages = [
  {
    title: 'Build Recurring Revenue',
    icon: 'fas fa-money-bill-wave',
    color: colors.indigo,
  },
  {
    title: 'Competitive Differentation',
    icon: 'fas fa-trophy',
    color: colors.orange,
  },
  {
    title: 'Keep Your Clients Loyal',
    icon: 'fas fa-heart',
    color: colors.red,
  },
  {
    title: 'Automated Sales Process',
    icon: 'fas fa-cog',
    color: colors.purple,
  },
  {
    title: '3rd-Party Integrations',
    icon: 'fas fa-plug',
    color: colors.blue,
  },
  {
    title: 'Meets Privacy Requirements',
    icon: 'fas fa-lock',
    color: colors.green,
  },
  {
    title: 'Marketing & Sales Collateral',
    icon: 'fas fa-hand-holding-heart',
    color: colors.pink,
  },
  {
    title: 'Integrates With Most Hardware',
    icon: 'fas fa-plus',
    color: colors.deepOrange,
  },
];

export const webinars = [
  {
    title: 'Manage Service Providers',
    description:
      'Add new recurring revenue streams to existing managed WiFi networks.',
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams@2x.jpg 2x',
    },
    authorName: 'Veronica Adams',
  },
  {
    title: 'Value Added Resellers',
    description:
      'Add Social WiFi Marketing to your software bundles and suite of services.',
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini@2x.jpg 2x',
    },
    authorName: 'Akachi Luccini',
  },
  {
    title: 'Digital Services Agencies',
    description:
      'Help local business owners generate leads and build customer loyalty.',
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith@2x.jpg 2x',
    },
    authorName: 'Jack Smith',
  },
  {
    title: 'Internet Service Providers',
    description:
      'Upsell Social WiFi as a Service to business Internet subscribers.',
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/kate-segelson.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/kate-segelson@2x.jpg 2x',
    },
    authorName: 'Kate Segelson',
  },
  {
    title: 'SaaS Aplications',
    description:
      'A lightweight Social WiFi API solution integrate deep into existing platforms.',
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/alex-johnson.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/alex-johnson@2x.jpg 2x',
    },
    authorName: 'Alex Johnson',
  },
  {
    title: 'Advertising Network',
    description:
      'Generate affiliate commissions by referring new reseller partners to us.',
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/valeria-kogan.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/valeria-kogan@2x.jpg 2x',
    },
    authorName: 'Valeria Kogan',
  },
];

export const platforms = [
  {
    logo: 'https://assets.maccarianagency.com/the-front/logos/slack.svg',
    name: 'Slack',
  },
  {
    logo: 'https://assets.maccarianagency.com/the-front/logos/mailchimp.svg',
    name: 'Mailchimp',
  },
  {
    logo: 'https://assets.maccarianagency.com/the-front/logos/dropbox.svg',
    name: 'Dropbox',
  },
  {
    logo: 'https://assets.maccarianagency.com/the-front/logos/google-drive.svg',
    name: 'Google Drive',
  },
  {
    logo: 'https://assets.maccarianagency.com/the-front/logos/google-ad-manager.svg',
    name: 'Google Ad Manager',
  },
  {
    logo: 'https://assets.maccarianagency.com/the-front/logos/atlassian.svg',
    name: 'Atlassian',
  },
];
